<template>
    <b-col>
        <b-row>
            <h3 class="ml-3">ASIN ändern</h3>
        </b-row>
        <b-row class="my-2">
            <b-col>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-button variant="primary" @click="origin.toggle()">{{origin.buttonName}}</b-button>
                    </b-input-group-prepend>
                    <b-form-input v-model="asin.old" :placeholder="origin.placeholder" :state="validateOrigin(asin.old)"/>
                </b-input-group>
            </b-col>
            <b-col>
                <b-form-input v-model="asin.new" placeholder="ASIN neu" :state="validateAsin(asin.new)"/>
            </b-col>
            <b-col class="col-1 ml-0 pl-0">
                <b-col/>
                <b-col class="p-0">
                <b-button block size="md" @click="submit()" variant="primary" :busy="busy">
                    <span class="icon icon-loop"/>
                </b-button>
                </b-col>
                <b-col/>
            </b-col>
        </b-row>
        <b-row class="my-2 py-2">
            <b-table
                v-if="asinChange"
                :items="asinChange"
                :fields="fields"
                :tbody-tr-class="rowClass"
                small
            >
                <template v-slot:cell(asinNew)="data">
                        <span style="font-family:'Lucida Console', monospace">{{data.item.asinNew}}</span>
                </template>
                <template v-slot:cell(asinOld)="data">
                        <span style="font-family:'Lucida Console', monospace">{{data.item.asinOld}}</span>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button size="sm" @click="openInNewTab(`material/${data.item.materialId}/edit`)" class="float-right">
                        <span class="icon icon-newspaper"></span>
                    </b-button>
                </template>
            </b-table>
        </b-row>
        <b-modal
            v-model="modalError.state"
            size="md"
            centered
            dismissible
        >
            {{modalError.message}}
        </b-modal>
    </b-col>
</template>
<script>
  export default
  {
        data() {
            return {
               users: [],
               origin: {
                   buttonName: 'Material ID', // if changed, replace buttonName and placeholder strings in whole component.
                   placeholder: 'Material ID',
                   parent: this,
                   toggle() {
                       this.parent.asin.old = "";
                       if(this.buttonName == 'Material ID') {
                           this.buttonName = 'ASIN';
                           this.placeholder = 'alte ASIN'
                       }else{
                           this.buttonName = 'Material ID';
                           this.placeholder = 'alte Material ID'
                       }
                   }
               },
               asin: {
                   old: "",
                   new: ""
               },
               asinPattern: /[A-Z0-9]{10}/g,
               modalError: {
                   state: false,
                   message: ""
               },
               fields: [
                   { key: 'asinOld', label: 'alte ASIN' },
                   { key: 'asinNew', label: 'neue ASIN' },
                   { key: 'created_at', label: 'erstellt am', formatter: function(s) { return (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '‒' } },
                   { key: 'finished_at', label: 'abgeschlossen am', formatter: function(s) { return (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '‒' } },
                   { key: 'actions', label: '' },
                   { key: 'requestJob', label: 'Zustand', 
                       formatter: function(requestJob) {
                           if(!requestJob) return "";
                           switch(requestJob.state) 
                           {
                               case 'created': return 'Metdatenanfrage läuft';
                               case 'error': return 'Fehler';
                               case 'actionRequired': return 'schwerer Fehler, bitte melden.';
                               default: return 'unbekannter Zustand';
                           }
                           //return requestJob.state
                       } 
                   },
                   {
                     key: "userId",
                     label: "Benutzer",
                     formatter: userId => {
                        if((!this.users) || (this.users.length == 0)) return "";
                        let maybe = this.users.find(user => user.id == userId);
                        return (maybe) ? maybe.name : "unbekannt";
                     }
                  },
               ],
               asinChange: null,
               regexAsinPattern: new RegExp('^[A-Z0-9]{10}$'),
               jobschedule: null,
               busy: false
            }
        },
        methods: {
            rowClass(item, type) {
                if(!item.requestJob) return "";
                if(item.requestJob.state == 'error') return 'table-danger';               
                return "";
            },
            submit() {
                this.busy = true;
                let post = null;

                if(!this.validateAsin(this.asin.new)) {
                    this.$bvToast.toast( "Vermeintliche neue ASIN (die ASIN die rechts steht) ist keine valide ASIN. Es kann sein, dass die ASIN versteckte Sonderzeichen enthält, tippen Sie vorsichtshalber die gesamte ASIN manuell über die Tastatur nach (also nicht kopieren).", {
                        title: "Material Asin Change",
                        autoHideDelay: 8000,
                        appendToast: false,
                        variant: 'danger',
                    });
                    return;
                }

                if(this.origin.buttonName == 'Material ID') 
                {
                    //refactor payload to reflect data structure;
                    let payload = {
                        materialId: this.asin.old,
                        new: this.asin.new
                    }
                    console.log("got here");
                    post = axios.post('asinchangejob/bymaterial', payload);
                }else{
                    if(!this.validateAsin(this.asin.old))
                    {
                        this.$bvToast.toast( "Vermeintliche alte ASIN (die ASIN die links steht) ist keine valide ASIN. Es kann sein, dass die ASIN versteckte Sonderzeichen enthält, tippen Sie vorsichtshalber die gesamte ASIN manuell über die Tastatur nach (also nicht kopieren).", {
                            title: "Material Asin Change",
                            autoHideDelay: 8000,
                            appendToast: false,
                            variant: 'danger',
                        });
                        return;
                    }
                    post = axios.post('/asinchangejob', this.asin);
                }
                
                post.then( response => {
                    console.log(response);
                    if(response.data === 'Unfinished job already exists') {
                        this.modalError = {
                            state: true,
                            message: `Ein offener Job mit mindestens einer dieser ASINs ( ${this.asin.old}, ${this.asin.new}) existiert bereits. Joberstellung wurde abgebrochen.`
                        };
                    }else if(response.data === 'Material mit alter ASIN existiert nicht.') {
                        this.modalError = {
                            state: true,
                            message: `Material mit alter ASIN (${this.asin.old}) existiert nicht.`
                        };
                    }else if(response.data === 'Zielasin existiert bereits.') {
                        this.modalError = {
                            state: true,
                            message: `Zielasin (${this.asin.new}) existiert bereits.`
                        };
                    }else if(response.data === 'Produkt kann im Metadatensystem nicht gefunden werden.') {
                        this.modalError = {
                            state: true,
                            message: `Produkt mit der ASIN (${this.asin.old}) kann im Metadatensystem nicht gefunden werden.`
                        };
                    }else{
                        this.asin.old = "";
                        this.asin.new = "";
                        this.reload();
                    }
                    this.busy = false;
                }).catch( error => {
                    console.error(error);
                    this.modalError = {
                        state: true,
                        message: "Netzwerkfehler. Error: " + JSON.stringify(error)
                    }
                    this.busy = false;
                });
            },
            openInNewTab(url) {
                var win = window.open(url, "_blank");
                win.focus();
            },
            reload()
            {
                this.busy = true;
                Promise.all([
                    axios.get( '/asinchangejob/getamount/100' ),
                    axios.get('/jobschedule/byclassname/C2_AsinChangeJob')
                ])
                .then( ([response, responseJobschedule]) => { 
                    this.asinChange = response.data;
                    this.jobschedule = responseJobschedule.data;
                }).then( () => {
                    let openJobs = this.asinChange.filter( elem => { if(!elem.finished_at) return elem });
                    if(0 != openJobs.length) axios.post( '/mds/request_job/get_bulk'
                    , { request_job_ids: openJobs.map( elem => elem.requestJobId ) 
                    }).then( response => {
                        openJobs.map( oj => oj.requestJob = response.data.find( elem => elem.id == oj.requestJobId ));
                        this.busy = false;
                    }).catch( error => {
                        console.log(error);
                        alert("Netzwerkfehler: Daten konnten nicht geladen werden.");
                        this.busy = false;
                    });
                });

            },
            validateOrigin(identifier) {
                if(this.origin.buttonName == 'Material ID') {
                    if(identifier == null || identifier.length == 0) return null;
                    return /^\d+$/.test(identifier);
                }else{
                    return this.validateAsin(identifier);
                }
            },
            validateAsin(asin) {

                if(asin == null || asin.length == 0) return null;
                return this.regexAsinPattern.test(asin) && (asin.length === 10);
            }
        },
        created() {
            this.reload();
            axios.get( "/user/get" ).then( response => (this.users = response.data));
        }
    }
</script>
